module.exports = __webpack_public_path__ + "img/WellenKönigin.5f6b669c.svg";